import React, { useState } from "react";
import { Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import { useTranslation } from "react-i18next";

const LayoutComponent = (props) => {
  const { t } = useTranslation();
  const stylingData = props.styleData;
  const [selectedStyle, setSelectedStyle] = useState("");
  function updateSelectedStyle(key, name) {
    setSelectedStyle(name);
    props.handleProperty(key, name);
  }
  const imgDivStyle = props.imgDivStyle;

  return (
    <div className={style.stylingComponent} key={selectedStyle} style={{marginLeft:props?.defaultSpacing ? "3%": null,marginBottom:props?.defaultSpacing ? "5%" : null,padding: props?.defaultSpacing ? "unset" :null}}
      id="afb_themeLayoutComponent"
    >
      {stylingData && stylingData.heading ? (
        <Col className={[style.layoutSubHeader].join(" ")}>
          {t(`${stylingData.heading}`)}{" "}
        </Col>
      ) : null}
      {stylingData && stylingData.children ? (
        <div className={style.stylingOptions}> 
          {stylingData.children.map((details, index) => {
            return (
              <div className={style.styleTypeParent} style={{marginBottom: props?.defaultSpacing ? "2%":null}}>
                <div className={style.styleType} style={props.layoutDivStyle}>
                  <div
                    className={[
                      props?.spacingTheme ? style.styleImgDiv1 :style.styleImgDiv,
                      props.selectedTheme &&
                      props.themeKey &&
                      props.selectedTheme[props.themeKey] &&
                      props.selectedTheme[props.themeKey][details.key] ===
                        details.label
                        ? style.selectedStyleImgDiv
                        : null,
                    ].join(" ")}
                    style={{ ...imgDivStyle, justifyContent: "center", ...props?.imgDivBasicThemeStyle }}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        updateSelectedStyle(details.key, details.label);
                      }
                    }}
                    onClick={() =>
                      updateSelectedStyle(details.key, details.label)
                    }
                  >
                    <img
                      src={details.imgSrc.default}
                      style={{
                        ...props.imgStyle,
                        height:props?.spacingTheme ? "unset":"100%",
                        width:props?.spacingTheme ? "90%":
                          (details?.key === "ControlStyle" ? "100%" : "92px"),
                      }}
                      onClick={() =>
                        updateSelectedStyle(details.key, details.label)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          updateSelectedStyle(details.key, details.label);
                        }
                      }}
                      alt="Update Selected Icon"
                    />
                  </div>
                  <span
                    className={style.styleTypeText}
                    style={{
                      ...props.labelStyle,
                      color:
                        props?.selectedTheme &&
                        props?.themeKey &&
                        props?.selectedTheme?.[props?.themeKey] &&
                        props?.selectedTheme?.[props?.themeKey][
                          details?.key
                        ] === details?.label
                          ? "#0072C6"
                          : "inherit",
                    }}
                    onClick={() =>
                      updateSelectedStyle(details?.key, details?.label)
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        updateSelectedStyle(details?.key, details?.label);
                      }
                    }}
                  >
                    {t(
                      `${
                        details.label === "Regular" ? "Regular " : details.label
                      }`
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default LayoutComponent;
